import { Loader2 } from 'lucide-react'
import { HELP_HTML_PROSE } from '../constants'
import type { HelpAboutContentProps } from '../types/components'

/**
 * Mirrors Angular `help-about.component.html`:
 * - loading row with spinner
 * - `#apphelpcontent` > `<p [innerHTML]="aboutContent">`
 */
export function HelpAboutContent({
  contentLoading,
  htmlContent,
}: HelpAboutContentProps) {
  return (
    <div className="add-company content_wrap">
      {contentLoading && (
        <div
          className="flex items-center gap-2 text-gray-600 mb-4"
          data-testid="dashboard-help-about-loading"
        >
          <Loader2 className="w-4 h-4 animate-spin" aria-hidden />
          <span>Loading</span>
        </div>
      )}

      <div id="apphelpcontent">
        {!contentLoading && htmlContent !== null && (
          <p
            data-testid="dashboard-help-about-api-content"
            className={HELP_HTML_PROSE}
            dangerouslySetInnerHTML={{ __html: htmlContent }}
          />
        )}
      </div>
    </div>
  )
}
